import { Box, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';
import { fMonthDayYearShort } from '../../../../utils/formatTime';

PreviouslyOrderedColumn.propTypes = {
  previouslyOrderedItems: PropTypes.array,
  sx: PropTypes.object,
};

export default function PreviouslyOrderedColumn({ previouslyOrderedItems, sx }) {

  return (
    <Tooltip
      slotProps={{
        popper: {
          sx: {
            "& .MuiTooltip-tooltip": {
              width: 'auto',
              maxWidth: 800,
              whiteSpace: "nowrap",

            },
          },
        },
      }}
      title={
        <Box>
          {previouslyOrderedItems?.map((item) => {
            const itemUOM =
              item.uomAmount && item.uomType
                ? `(${item.uomAmount} / ${item.uomType})`
                : item.uomAmount
                  ? `(UOM ${item.uomAmount})`
                  : item.uomType
                    ? `(UOM ${item.uomType})`
                    : ``;
            return (
              <Box key={item.orderNumber}>
                Order# {item.orderNumber}, SKU {item.item}, Qty {item.ordered} {itemUOM}, {fMonthDayYearShort(item.orderedOn)}
              </Box>
            );
          })
          }
        </Box>
      }
    >
      <Box component="div" sx={{ wordWrap: 'break-word', whiteSpace: 'pre-wrap', fontSize: '0.7rem' }}      >
        <Box sx={{ minWidth: '40px', ...sx }}>
          {`${previouslyOrderedItems?.slice(0, 10)?.map((item) => item.ordered).join(', ') || ""}`}
        </Box>
      </Box>
    </Tooltip>
  )
}
